const LOGO_URL =
  "/media/grozny-logo.png";

export const Logo = ({ size = "md", className = "" }) => {
  const h = size === "lg" ? "h-14" : size === "xl" ? "h-24 sm:h-28" : "h-10";
  return (
    <img
      src={LOGO_URL}
      alt="GROZNY LOCATION"
      className={`${h} w-auto object-contain select-none transition-transform duration-700 ease-out group-hover:scale-[1.03] ${className}`}
      draggable="false"
    />
  );
};
